export const PO_PAY_STATUS = {
  YES: 'Y'
}
